import { useDispatch, useSelector } from "react-redux";
import User from "../../../models/User";
import { getErrorMessage } from "../../../utils/errorUtils";
import logger from "../../../utils/logger";

const initialState = {
	isLoading: false,
	error: null,
	admins: [],
	reps: []
};

const usersReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case "ADMINS_FOUND":
			return {
				...state,
				admins: payload.records
			};
		case "REPS_FOUND":
			return {
				...state,
				reps: payload.records
			};
		default:
			return state;
	}
};

export const getAdmins = () => {
	return async (dispatch) => {
		try {
			const records = await User.getAdmins({});
			dispatch({ type: "ADMINS_FOUND", payload: { records: records } });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
		}
	}
};


export const getReps = () => {
	return async (dispatch) => {
		try {
			const records = await User.getReps({});
			dispatch({ type: "REPS_FOUND", payload: { records: records } });
		} catch (error) {
			logger.logReduxErrorEvent(error, getErrorMessage(error), true);
			throw error;
		}
	}
};

export const useUsers = () => {
	const dispatch = useDispatch();

	return {
		admins: useSelector((appState) => appState.users.admins),
		reps: useSelector((appState) => appState.users.reps),
		fetchAdmins: () => dispatch(getAdmins()),
		fetchReps: () => dispatch(getReps())
	};
};

export default usersReducer;